import { FilterChip, FilterItem } from '@direct-frontend/components';
import { type Filter } from '@adv-frontend/filters';

type ExistenceFilterProps = {
    id: string;
    title: string;
};

export const createExistenceFilter = (props: ExistenceFilterProps): Filter<string, string> => {
    const { id, title } = props;

    return {
        id,
        title,
        reconcile: ({ value }) => {
            return { value: value.includes('id') ? id : '' };
        },

        validate: () => null,
        hasValue: ({ value }) => value !== '',

        getDefaultValue: () => {
            return { value: title, operator: '=' };
        },

        render: (props) => (
            <FilterItem
                color="normal"
                size="xs"
                keyChip={<FilterChip>{title}</FilterChip>}
                onRemove={() => {
                    props.onRemove();
                }}
            />
        ),
    };
};
